import { CommonOnboardingPage, CoreOnboardingPage, MemberProgram, NpOnboardingPage } from 'app-pages/pages/constants';
import { useMutation } from 'react-query';

import axiosInstance from '../../helpers/axiosInstance';

export const useNextStep = () => {
  return useMutation({
    mutationFn: async (params: useNextStepParams) => {
      return axiosInstance
        .post<useNextStepResponse>('/patients/experience/next_step', {
          page: params.page,
          patient_id: params.patientId,
          patient_consult_id: params.patientConsultId,
          program: params.program,
        })
        .then(async (r) => r.data);
    },
  });
};

type useNextStepParams = {
  page: CommonOnboardingPage | CoreOnboardingPage | NpOnboardingPage;
  patientId?: string;
  patientConsultId?: string;
  program?: MemberProgram;
};

export enum NextStepActions {
  RedirectToStripe = 'redirect_to_stripe',
}

type useNextStepResponse = {
  url: NextStepActions | string;
};
